"use client"
import SectionPage from "@/components/common/section-page";
import SectionTitle from "@/components/common/section-title";
import { useEffect, useMemo } from "react";

import {
    Carousel,
    CarouselContent,
    CarouselItem
} from "@/components/ui/carousel";
import { PostCard, PostHoriezontalCard, PostImageBgCard } from "./post-cards";
import { usePosts } from "./posts.provider";

export function PostBasePageContent() {
    const { posts, setCurrentPost } = usePosts();

    // Réinitialiser l'article courant quand on arrive sur la page de liste
    useEffect(() => {
        setCurrentPost(undefined);
    }, [setCurrentPost]);

    const aLaUne = useMemo(() => posts?.filter((item) => item.aLaUne), [posts]);
    const autresArticles = useMemo(() => posts?.filter((item) => !item.aLaUne), [posts]);
    const hasALaUneSecondaire = useMemo(() => posts?.some((item) => item.aLaUneSecondaire), [posts]);
    const aLaUneSecondaire = useMemo(() => posts?.filter((item) => item.aLaUneSecondaire), [posts]);

    return (
        <>

            {/* Flash Infos Content */}
            {/* Articles à la une */}
            <SectionPage sectionType="2xl">
                <SectionTitle title="A la une" skin="bleuMarine" />
                {!hasALaUneSecondaire && <>
                    {aLaUne?.length > 1 && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                        {aLaUne
                            ?.map((post) => (
                                <PostCard key={post.slug} post={post} setCurrentPost={setCurrentPost} />
                            ))}
                    </div>}

                    {aLaUne?.length === 1 && (
                        <div className="text-center py-10">
                            <PostImageBgCard post={aLaUne[0]} setCurrentPost={setCurrentPost} />
                        </div>
                    )}
                    {aLaUne?.length === 0 && (
                        <div className="text-center py-10">
                            <p className="text-gray-500">Aucune actualité disponible pour le moment.</p>
                        </div>
                    )}
                    {aLaUne?.length > 1 && <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                        {aLaUne
                            ?.map((post) => (
                                <PostCard key={post.slug} post={post} setCurrentPost={setCurrentPost} />
                            ))}
                    </div>}

                    {aLaUne?.length === 0 && (
                        <div className="text-center py-10">
                            <p className="text-gray-500">Aucune actualité disponible pour le moment.</p>
                        </div>
                    )}</>}

                {hasALaUneSecondaire && <>
                    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                        <div className="md:col-span-2">
                            {/* a la une en carousel de FlashInfoCardImgBg */}
                            <Carousel className="w-full">
                                
                                <CarouselContent>
                                    {aLaUne?.map((post, index) => (
                                        <CarouselItem key={index}>
                                            <PostImageBgCard post={post} setCurrentPost={setCurrentPost} />
                                        </CarouselItem>
                                    ))}
                                </CarouselContent>
                                <div className="flex justify-center absolute bottom-4 left-1/2 -translate-x-1/2">
                                    {/* afficher les bullets du carousel */}
                                    <div className="flex items-center gap-2">
                                        {aLaUne?.map((_, index) => (
                                            <div key={index} className="w-2 h-2 rounded-full bg-gray-300"></div>
                                        ))}
                                    </div>
                                </div>
                            </Carousel>
                        </div>

                        {/* Articles récents */}
                        <div className="flex flex-col gap-6 bg-slate-100 p-6">
                            <SectionTitle title="Articles récents" skin="bleuMarine" size="small" />
                            {aLaUneSecondaire?.map((post) => (
                                <PostHoriezontalCard key={post.slug} post={post} setCurrentPost={setCurrentPost} />
                            ))}
                        </div>
                    </div>
                </>}
            </SectionPage>

            {/* aAutres articles */}
            {autresArticles && autresArticles?.length > 0 && <SectionPage sectionType="2xl">
                <SectionTitle title="Autres articles" skin="bleuMarine" size="small" />
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mt-8">
                    {autresArticles
                        ?.map((post) => (
                            <PostHoriezontalCard key={post.slug} post={post} setCurrentPost={setCurrentPost} />
                        ))}
                </div>
            </SectionPage>}

            {/* Lorsqu'il n'y a pas d'article */}
            <SectionPage sectionType="2xl">
                {posts.length === 0 && (
                    <div className="text-center py-10">
                        <p className="text-gray-500">Aucune actualité disponible pour le moment.</p>
                    </div>
                )}
            </SectionPage>
        </>
    );
}
